import { Component, Input } from '@angular/core';
import { InputComponent } from '../input/input.component';

/**
 * Checkbox component to display a checkbox with label and validation messages.
 *
 * @example
 * <cfe-input-checkbox-small
 *                [control]="formControl"
 *                [label]="'A checkbox'"
 *                [id]="'unique-identifier'"
 *                [tabIndex]="1"
 *                [disabled]="false"
 *                [notMarkAsRequired]="false">
 * </cfe-input-checkbox-small>
 */

@Component({
	selector: 'cfe-input-checkbox-small',
	templateUrl: './input-checkbox-small.component.html',
	styleUrls: ['./input-checkbox-small.component.scss']
})
export class InputCheckboxSmallComponent extends InputComponent {
	constructor() {
		super();
	}
}
